


import UMUM from '../../library/umum'
import FETCHING from '../../library/fetching'


export default {
  data() {
    return {


      form: {
        id: '',
        uraian: '',
        keterangan: '',
        file: null,
        file_old: '',
        unit_kerja: '',
        status: 0,
      },

      filterku: {
        unit_kerja_id: '',
        is_private: 0,
      },

      opsiPrivate: [
        { id: 0, value: 'Non Private'},
        { id: 1, value: 'Private'},
      ],

      list_data: [],


      page_first: 1,
      page_last: 0,
      page_limit: 10,
      cari_value: "",
      cek_load_data: true,
      file_path: this.$store.state.url.URL_APP + "uploads/",

      mdl_add: false,
      mdl_edit: false,
      mdl_hapus: false,
      mdl_chat: false,
      mdl_maps: false,
      btn_add: false,
      mdl_img: false,


      UMUM: UMUM,
      FETCHING : FETCHING,
    }
  },
  methods: {


    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_presensi_settingProfile + "viewData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          unit_kerja_id: this.filterku.unit_kerja_id,
          is_private: this.filterku.is_private,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          // console.log(res_data);
        });
    },

    setujui: async function () {
      await this.UMUM.confirmx('anda akan verifikasi data ini?')
      fetch(this.$store.state.url.URL_presensi_settingProfile + "changeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          id: this.form.id,
          status: 1,
          keterangan: "Data telah diverifikasi",
        })
      }).then(res_data => {
        this.Notify('Sukses mengonfirmasi Usulan', 'primary', 'check_circle_outline');
        this.getView();
      });
    },

    kembalikan: async function () {

      fetch(this.$store.state.url.URL_presensi_settingProfile + "changeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          id: this.form.id,
          status: 2,
          keterangan: this.form.keterangan,
        })
      }).then(res_data => {
        this.Notify('Sukses mengembalikan usulan', 'negative', 'check_circle_outline');
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.uraian = data.uraian;
      this.form.keterangan = data.keterangan;
      this.form.file = data.file;
      this.form.file_old = data.file;
      this.form.unit_kerja = data.unit_kerja;
      this.form.verificationBy = data.verificationBy;
      this.form.status = data.status;
    },

    indexing : function(index){
        var idx = ((this.page_first-1)*this.page_limit)+index
        return idx;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: 'top',
        timeout: 500,
      })
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    indicatorColor: function (data) {
      if (data == 0) {
        return {
          bg: `bg-orange-2`,
          status: false
        }
      }
      else if (data == 1) {
        return {
          bg: `bg-blue-1`,
          status: false
        }
      }
      else if (data == 2) {
        return {
          bg: `bg-red-2`,
          status: true
        }
      }

    },

    filterUnitKerja: function (val, update, abort) {
      update(() => {
        if (val === '') { }
        else { FETCHING.postUnitKerjaAuto(val) }
      })
    },


    // ====================================== PAGINATE ====================================







  },

  mounted() {

    this.filterku.unit_kerja_id = this.$store.state.unit_kerja
    this.FETCHING.postUnitKerjaAuto('', this.filterku.unit_kerja_id)
    this.getView();





  },
}
